export enum NavigationRoutes {
  DASHBOARD = "/dashboard",
  RETURN_DETAILS = "/retour/details",
  CANCELED_RETURN_DETAILS = "/retour/annulee/details",
  RETURN_EXPEDITION_VALIDATION = "/retour/validation-expedition",
  RETURN_CREATE = "/retour/create",
  REQUEST_RETURN_CREATE = "/retour-request/create",
  RETURN_PICK_UP_VALIDATION = "/retour/validation-ramassage",
  BULK_PICK_UP_VALIDATION = "/retour/validation-ramassage-masse",
  RETURN_DELIVERY_VALIDATION = "/retour/validation-livraison",
  ROOT = "/",
  NOT_FOUND = "*",
  NOT_AUTHORIZED = "/not-authorized",
  RETURN_LITIGE = "/retour/litige",
  LITIGE_DETAILS = "/litige/details",
  LITIGE_PRODUCT_DETAILS = "/litige/product-details",
  PJ = "/retour/pj",
  REQUEST_LITIGE = "/demande/litige",
  COLIS_SCAN = "/colis/scan",
  RTO_PACKAGE = "/rto/package",
  PARTIAL_RECEPTION_VALIDATION = "/retour/validation-reception-partielle",
  PARTIAL_RECEPTION_PJ = "/retour/pj-reception-partielle",
}
